import React from 'react';
const YouTubeIcon = ({ fill, width, height, opacity }) => (
    <svg width={width} height={height} viewBox="0 0 30 30">
        <path
            fill={fill}
            opacity={opacity}
            d="M15,0c4.1,0,7.9,1.7,10.6,4.4C28.3,7.1,30,10.9,30,15c0,4.1-1.7,7.9-4.4,10.6C22.9,28.3,19.1,30,15,30
	s-7.9-1.7-10.6-4.4C1.7,22.9,0,19.1,0,15c0-4.1,1.7-7.9,4.4-10.6C7.1,1.7,10.9,0,15,0L15,0z M24.8,5.2c-2.5-2.5-6-4-9.8-4
	s-7.3,1.5-9.8,4c-2.5,2.5-4.1,6-4.1,9.8c0,3.8,1.5,7.3,4.1,9.8c2.5,2.5,6,4.1,9.8,4.1s7.3-1.6,9.8-4.1c2.5-2.5,4.1-6,4.1-9.8
	C28.8,11.2,27.3,7.7,24.8,5.2L24.8,5.2z"
        />
        <path
            fill={fill}
            opacity={opacity}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5,11.8c0,0-0.2-1.1-0.6-1.6c-0.6-0.6-1.2-0.6-1.5-0.7C18.2,9.4,15,9.4,15,9.4h0c0,0-3.2,0-5.3,0.2
	c-0.3,0-1,0.1-1.5,0.7c-0.5,0.5-0.6,1.6-0.6,1.6s-0.2,1.3-0.2,2.6v0.2v1.1c0,1.3,0.2,2.6,0.2,2.6s0.2,1.1,0.6,1.6
	c0.6,0.6,1.3,0.6,1.7,0.7c1.2,0.1,5.2,0.2,5.2,0.2s3.2,0,5.4-0.2c0.3,0,0.9,0,1.5-0.7c0.5-0.5,0.6-1.6,0.6-1.6s0.1-1.3,0.1-2.6v-1
	v-0.2C22.7,13.1,22.5,11.8,22.5,11.8L22.5,11.8z M17.6,14.8l-4.1,2.2v-3.4v-1l1.9,1L17.6,14.8z"
        />
    </svg>
);

export default YouTubeIcon;
